import { Controller } from "@hotwired/stimulus"
import { syncGateReason } from "../lib/gate_reason"

// Step 2 Continue gate: disabled until phone-verification-inline:verified fires (server save_verification re-enforces it).
// Email verification is tracked (email-verification-poller:verified / email-edit:email-changed) for the badge, but does not gate Continue.
export default class extends Controller {
  static targets = ["continueBtn"]
  static values  = { phoneVerified: Boolean, emailVerified: Boolean }

  connect() {
    this._phoneVerified = this.phoneVerifiedValue
    this._emailVerified = this.emailVerifiedValue

    this._onPhoneVerified = () => { this._phoneVerified = true; this.refreshContinue() }
    this._onEmailVerified = () => { this._emailVerified = true; this.refreshContinue() }
    // Email changed: new address is unverified. Tracked for the badge only —
    // refreshContinue() does not factor _emailVerified in, so this does not
    // re-disable Continue.
    this._onEmailChanged = () => { this._emailVerified = false; this.refreshContinue() }
    this.element.addEventListener("phone-verification-inline:verified", this._onPhoneVerified)
    this.element.addEventListener("email-verification-poller:verified", this._onEmailVerified)
    this.element.addEventListener("email-edit:email-changed", this._onEmailChanged)

    this.refreshContinue()
  }

  disconnect() {
    this.element.removeEventListener("phone-verification-inline:verified", this._onPhoneVerified)
    this.element.removeEventListener("email-verification-poller:verified", this._onEmailVerified)
    this.element.removeEventListener("email-edit:email-changed", this._onEmailChanged)
  }

  refreshContinue() {
    if (!this.hasContinueBtnTarget) return
    const ready = this._phoneVerified
    syncGateReason(this.continueBtnTarget, { ready, reason: ready ? "" : "Verify your phone above to continue." })
  }
}
